import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Users, IndianRupee, ArrowRight } from 'lucide-react';
import { vehicleFleet } from '../data/mock';

const VehicleFleet = () => {
  return (
    <section id="fleet" className="py-16 md:py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
            Our Vehicle Fleet
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            Clean • Comfortable • Well-Maintained
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Choose from our wide range of vehicles designed for every type of journey and group size.
          </p>
        </div>

        {/* Vehicle Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {vehicleFleet.map((vehicle) => (
            <Card 
              key={vehicle.id} 
              className="group bg-white border-0 shadow-lg shadow-slate-200/50 rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-xl font-bold text-white">{vehicle.name}</h3>
                </div>
              </div>
              <CardContent className="p-5">
                <p className="text-slate-600 text-sm mb-4 line-clamp-2">
                  {vehicle.description}
                </p>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-1 text-slate-500 text-sm">
                    <Users className="w-4 h-4" />
                    <span>{vehicle.capacity}</span>
                  </div>
                  <div className="flex items-center gap-1 text-amber-600 font-bold">
                    <IndianRupee className="w-4 h-4" />
                    <span>{vehicle.pricePerKm}/km</span>
                  </div>
                </div>
                <Button 
                  variant="outline" 
                  className="w-full border-amber-200 text-amber-600 hover:bg-amber-50 hover:border-amber-300 rounded-xl group/btn transition-all duration-200"
                >
                  Book Now
                  <ArrowRight className="w-4 h-4 ml-1 group-hover/btn:translate-x-1 transition-transform" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Note */}
        <p className="text-center text-slate-500 mt-8 text-sm">
          All vehicles are regularly maintained to ensure safety and comfort.
        </p>
      </div>
    </section>
  );
};

export default VehicleFleet;
